<template>
  <section class="section-index-table section-table-users">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 index-table-col">
          <table class="index-table">
            <tr>
<!--              <th class="th-signal" v-on:click="sortStatus()"><span v-bind:class="{active :(sort.status === SORT_ASC)}"></span></th>-->
              <th class="th-name" v-on:click="sortTitle()">
                <span v-bind:click="{desk : (sort.title === SORT_ASC)}">Полное имя</span>
              </th>
              <th class="th-num" v-on:click="sortCount()"><span v-bind:class="{active :(sort.count === SORT_ASC)}">Id</span></th>
              <th class="th-power-peak" v-on:click="sortPowerPeak()"><span v-bind:class="{active : (sort.powerP === SORT_ASC)}">Email</span></th>
              <th class="th-power-peak" v-on:click="sortPowerPeak()"><span v-bind:class="{active : (sort.powerP === SORT_ASC)}">Организация</span></th>
              <th class="th-power-today" v-on:click="sortPowerDay()"><span v-bind:class="{active : (sort.powerD === SORT_ASC)}">Станции</span></th>
<!--              <th class="th-last-update" v-on:click="sortTime()"><span v-bind:class="{active : (sort.time === SORT_ASC)}">Логин</span></th>-->
<!--              <th class="th-last-update" v-on:click="sortTime()"><span v-bind:class="{active : (sort.time === SORT_ASC)}">Роли</span></th>-->
            </tr>
            <tr v-for="usersTable in users" v-bind:key="usersTable.id" v-on:click="openEdit(usersTable.id)">
<!--              <td>-->
<!--                <img v-if="usersTable.signal" src="../../assets/images/img-svg/signal-1.svg" width="24" height="18">-->
<!--                <img v-else src="../../assets/images/img-svg/signal-2.svg" width="24" height="18">-->
<!--              </td>-->
              <td>
                <a href="#">{{ usersTable.login }}</a>
                <div class="buttons-users-actions buttons-station-actions">
                  <span v-on:click.stop="deleteUser(usersTable.id)" :style="{color: 'red'}">DELETE</span>
<!--                  <span v-on:click.stop="block(usersTable.id)" :style="{color: 'orange'}">BLOCK</span>-->
                </div>
              </td>
              <td><div><span>Id</span><b></b><i>{{usersTable.id}}</i></div></td>
              <td><div><span>Email</span><b></b><i>{{usersTable.email}}</i></div></td>
              <td><div><span>Организация</span><b></b><i>{{usersTable.organisation.toString().replace('.',',')}}</i></div></td>
              <td><div>
                <span>Станции</span>
                <b></b>
                <i>
                  <div :key="stationId" v-for="stationId in usersTable.stations">{{stations[stationId]}}
                    <br>
                  </div>
                </i>
              </div></td>
<!--              <td><div><span>Последнее обновление</span><b></b><i>{{formatDate(usersTable.lastUpdate)}}</i></div></td>-->
<!--              <td><div><span>Логин</span><b></b><i>{{usersTable.login}}</i></div></td>-->
<!--              <td><div><span>Роли</span><b></b><i>{{usersTable.roles.toString().replace('.',', ')}}</i></div></td>-->
            </tr>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <router-link to="/user-create">
          <div class="add-users-button add-station-button">
              <span></span>
              Добавить пользователя
          </div>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import moment from 'moment'
import collection from 'lodash/collection'
import UsersAPI from '../../api/users'

const SORT_ASC = 'asc'
const SORT_DESC = 'desc'
const SORT_UNSORTED = 'unsorted'

export default {
  name: 'UsersTable',
  data () {
    return {
      SORT_ASC: SORT_ASC,
      SORT_DESC: SORT_DESC,
      SORT_UNSORTED: SORT_UNSORTED,
      //      usersTables: [
      //        {
      //          id: 0,
      //          signal: true,
      //          name: 'a-Тестовая станция_20 kW',
      //          countInverters: 1,
      //          powerPeak: 3.1,
      //          powerDay: 61.97,
      //          lastUpdate: 1559655420,
      //          errorsToday: 13
      //        },
      //      ],
      sort: {
        status: SORT_UNSORTED,
        fullN: SORT_UNSORTED,
        count: SORT_UNSORTED,
        powerP: SORT_UNSORTED,
        powerD: SORT_UNSORTED,
        update: SORT_UNSORTED,
        errors: SORT_UNSORTED
      }
    }
  },
  computed: {
    isLoading () {
      return this.$store.getters[ 'users/isLoading' ]
    },
    hasError () {
      return this.$store.getters[ 'users/hasError' ]
    },
    error () {
      return this.$store.getters[ 'users/error' ]
    },
    hasStations () {
      return this.$store.getters[ 'users/hasPosts' ]
    },
    users () {
      return this.$store.getters[ 'users/users' ]
    },
    stations () {
      return this.$store.getters[ 'users/stations' ]
    }
  },
  created () {
    this.$store.dispatch('users/findAll')
  },
  methods: {
    openEdit (id) {
      this.$router.push({ name: 'user-edit', params: { id: id } })
    },
    showStation (id) {
      this.$router.push({ name: 'users-view', params: { id: id } })
    },
    sortTable (sortStatus, fieldName) {
      if ((sortStatus === SORT_UNSORTED) || (sortStatus === SORT_DESC)) {
        this.usersTables = collection.orderBy(this.usersTables, [fieldName], ['asc'])
        return SORT_ASC
      } else {
        this.usersTables = collection.orderBy(this.usersTables, [fieldName], ['desc'])
        return SORT_DESC
      }
    },
    sortStatus () {
      this.sort.status = this.sortTable(this.sort.status, 'signal')
    },
    sortTitle () {
      this.sort.fullN = this.sortTable(this.sort.fullN, 'fullName')
    },
    sortCount () {
      this.sort.count = this.sortTable(this.sort.count, 'totalPower')
    },
    sortPowerPeak () {
      this.sort.powerP = this.sortTable(this.sort.powerP, 'powerPeak')
    },
    sortPowerDay () {
      this.sort.powerD = this.sortErrors(this.sort.powerD, 'powerDay')
    },
    sortTime () {
      this.sort.time = this.sortTable(this.sort.time, 'lastUpdate')
    },
    sortErrors () {
      this.sort.errors = this.sortTable(this.sort.errors, 'errorsToday')
    },
    formatDate (timestamp) {
      return moment.unix(timestamp).subtract(2, 'hours').format('DD/MM/YYYY HH:mm')
    },
    block (id) {
      if (confirm('Block user: ' + id + '?')) {
        let self = this
        UsersAPI.block(id).then(() => {
          self.$store.dispatch('users/findAll')
        })
      }
    },
    deleteUser (id) {
      if (confirm('Delete user: ' + id + '?')) {
        let self = this
        UsersAPI.deleteUser(id).then(() => {
          self.$store.dispatch('users/findAll')
        })
      }
    }
  }
}
</script>
